import { Link } from "react-router-dom";

const Terms = () => {
  return (
    <div className="min-h-screen bg-black text-white font-mono p-4 pt-16 pb-24">
      <div className="prose prose-invert max-w-3xl mx-auto">
        <div className="mb-12">
          <Link
            to="/"
            className="text-cyan-400 no-underline hover:text-cyan-300 transition-colors"
          >
            ← Back to Home
          </Link>
        </div>

        <h1 className="text-4xl font-bold text-cyan-400 mb-8">
          Terms of Service
        </h1>

        <p className="mb-6">
          Before using the service, users must agree to the following terms:
        </p>

        <div className="space-y-4">
          <p>
            This service is offered as a research preview and includes only
            limited safety measures. It may produce offensive content. Users are
            prohibited from uploading any private or sensitive information. The
            service collects dialogue data, and reserves the right to distribute
            this data under a Creative Commons Attribution (CC-BY) license.
          </p>

          <p className="font-semibold">
            The content on the website does not reflect the perspectives of the
            creators or affiliated institutions engaged.
          </p>

          <h2 className="text-2xl font-semibold text-cyan-400 mt-8 mb-4">
            1. Acceptance of Terms
          </h2>
          <p>
            By accessing or using the RedTeam Arena service, you agree to be bound
            by these Terms of Service. If you disagree with any part of the
            terms, you may not access the service.
          </p>

          <h2 className="text-2xl font-semibold text-cyan-400 mt-8 mb-4">
            2. Description of Service
          </h2>
          <p>
            RedTeam Arena is a research preview service that allows users to
            interact with an AI model. The service is provided "as is" and may
            be subject to changes or termination at any time without notice.
          </p>

          <h2 className="text-2xl font-semibold text-cyan-400 mt-8 mb-4">
            3. User Responsibilities
          </h2>
          <ul className="list-disc list-inside space-y-2">
            <li>You must be at least 18 years old to use this service.</li>
            <li>
              You are responsible for maintaining the confidentiality of your
              account and password.
            </li>
            <li>
              You agree not to use the service for any illegal or unauthorized
              purpose.
            </li>
            <li>
              You must not upload any private or sensitive information to the
              service.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold text-cyan-400 mt-8 mb-4">
            4. Content and Conduct
          </h2>
          <p>
            The service may produce offensive or inappropriate content. Users
            are advised to use discretion and judgment when interacting with the
            AI model. RedTeam Arena is not responsible for any content generated by
            the AI or submitted by users.
          </p>

          <h2 className="text-2xl font-semibold text-cyan-400 mt-8 mb-4">
            5. Data Collection and Use
          </h2>
          <p>
            The service collects dialogue data from user interactions. By using
            the service, you grant RedTeam Arena the right to collect, store, and
            potentially distribute this data under a Creative Commons
            Attribution (CC-BY) license.
          </p>

          <h2 className="text-2xl font-semibold text-cyan-400 mt-8 mb-4">
            6. Limitation of Liability
          </h2>
          <p>
            RedTeam Arena shall not be liable for any indirect, incidental, special,
            consequential or punitive damages, or any loss of profits or
            revenues, whether incurred directly or indirectly, or any loss of
            data, use, goodwill, or other intangible losses, resulting from your
            access to or use of or inability to access or use the service.
          </p>

          <h2 className="text-2xl font-semibold text-cyan-400 mt-8 mb-4">
            7. Changes to Terms
          </h2>
          <p>
            We reserve the right to modify or replace these terms at any time.
            It is your responsibility to check the Terms periodically for
            changes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
